import React from 'react';
import PropTypes from 'prop-types';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const Lock = ({
  size = 16,
  title = 'Lock',
  fill = colors.silverSandAlt,
  className = '',
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 15.37 20"
      className={className}
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        fill={fill}
        d="M565.34,1164.6h1.022c.333.057.666.1,1,.176a5.987,5.987,0,0,1,2.886,1.664,6.225,6.225,0,0,1,1.7,3.265,11.434,11.434,0,0,1,.113,2.16v.818h.333a1,1,0,0,1,.865.486,1.665,1.665,0,0,1,.273.979v8.987a2.792,2.792,0,0,1-.033.37,1.178,1.178,0,0,1-1.258,1.092h-12.9a1.037,1.037,0,0,1-.912-.5,1.751,1.751,0,0,1-.266-1v-8.917a2.738,2.738,0,0,1,.033-.406,1.178,1.178,0,0,1,1.258-1.092h0a.952.952,0,0,0,.186,0v-1.7a6.275,6.275,0,0,1,1.684-4.383,5.808,5.808,0,0,1,2.8-1.73A8.975,8.975,0,0,1,565.34,1164.6Zm4.137,8.055v-1.814a3.661,3.661,0,0,0-3.661-3.661h-.28a3.6,3.6,0,0,0-3.222,2.939,22.215,22.215,0,0,0-.083,2.49s0,.02.027.03Zm-4.859,7.389v1.248a.6.6,0,0,0,.519.666.53.53,0,0,0,.143,0h1.092c.486,0,.7-.22.7-.706v-2.44a.665.665,0,0,1,.123-.333,1.578,1.578,0,0,0,.353-1.088,1.681,1.681,0,0,0-1.721-1.641,1.716,1.716,0,0,0-.592.123,1.667,1.667,0,0,0-.742,2.622.533.533,0,0,1,.11.313c.02.423,0,.839,0,1.255Z"
        transform="translate(-558.166 -1164.6)"
      />
    </svg>
  );
};

Lock.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  fill: PropTypes.string,
};

Lock.defaultProps = {
  size: 16,
  title: 'Lock',
  fill: colors.silverSandAlt,
};
